import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Table, Typography } from 'antd';
import { useEffect, useState } from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';
import ProjectDetailMultiproductModal from './ProjectDetailMultiproductModal';
import { getPrjEEMasterProducts } from '../../services/projectService';
const ProjectDataTable = ({ data, tableDataItem, loading, pagination, onChange, searchPrjRequest }) => {
    const [tableData, setTableData] = useState([]);
    const [isModalOpenMP, setIsModalOpenMP] = useState(false);
    const [lstMultiProduct, setLstMultiProduct] = useState([]);
    useEffect(() => {
        if (data) {
            const newData = data.map((item, index) => {
                var _a, _b, _c, _d, _e;
                return {
                    key: index,
                    entityname: `${(_b = (_a = item.objClientMaster) === null || _a === void 0 ? void 0 : _a.objLuCompany) === null || _b === void 0 ? void 0 : _b.strLongDesc}`,
                    productmodel: item.boolIsMultipleProdReq ?
                        _jsx(Typography.Link, { onClick: (e) => handleOpenMultiProdModal(item === null || item === void 0 ? void 0 : item.strProjectId), children: "View Details" })
                        : `${item.strPrimaryModel}`,
                    brand: item.boolIsMultipleProdReq ?
                        _jsx(Typography.Link, { onClick: (e) => handleOpenMultiProdModal(item === null || item === void 0 ? void 0 : item.strProjectId), children: "View Details" })
                        : `${(_c = item.objBrandName) === null || _c === void 0 ? void 0 : _c.strLongDesc}`,
                    projectno: `${item.strProjectId}`,
                    projecttype: `${item.strNewOrRenewal}`,
                    projectstatus: `${(_d = item.objProjectStatus) === null || _d === void 0 ? void 0 : _d.strLongDesc}`,
                    riskstatus: `${item.strRiskStatusDesc}`,
                    productname: item.boolIsMultipleProdReq ?
                        _jsx(Typography.Link, { onClick: (e) => handleOpenMultiProdModal(item === null || item === void 0 ? void 0 : item.strProjectId), children: "View Details" })
                        : `${item.strProductNameEN}`,
                    rdate: `${item.strdtProjPlannedStartDate}`,
                    pdate: item.strdtProjEstCompetionDate != null && item.strdtProjEstCompetionDate != item.strdtProjDueDate ? `${item.strdtProjEstCompetionDate}` : `${item.strdtProjDueDate}`,
                    adate: `${item.strdtProjActCompetionDate == undefined ? '' : item.strdtProjActCompetionDate}`,
                    blocation: `${(_e = item.objBusinessUnit) === null || _e === void 0 ? void 0 : _e.strBusinessUnitName}`
                };
            });
            setTableData(newData);
        }
    }, [data]);
    const columns = [
        {
            title: 'Entity Name',
            width: 120,
            dataIndex: 'entityname',
            key: 'entityname'
        },
        {
            title: 'Project No.',
            width: 120,
            dataIndex: 'projectno',
            key: 'projectno',
            render: (text, record) => {
                var _a;
                return (_jsx(Link, { to: `/projects/details/${btoa(((_a = record.projectno) === null || _a === void 0 ? void 0 : _a.toString()) || '')}`, target: "_blank", children: record.projectno }));
            }
        },
        {
            title: 'Project Type',
            width: 120,
            dataIndex: 'projecttype',
            key: 'projecttype'
        },
        {
            title: 'Project Status',
            width: 120,
            dataIndex: 'projectstatus',
            key: 'projectstatus'
        },
        {
            title: 'Risk Status',
            width: 120,
            dataIndex: 'riskstatus',
            key: 'riskstatus'
        },
        {
            title: 'Product Name',
            width: 140,
            dataIndex: 'productname',
            key: 'productname'
        },
        {
            title: 'Brand/OEM',
            dataIndex: 'brand',
            key: 'brand',
            width: 120
        },
        {
            title: 'Product Model',
            width: 140,
            dataIndex: 'productmodel',
            key: 'productmodel'
        },
        {
            title: 'Recommended Start Date',
            width: 140,
            dataIndex: 'rdate',
            key: 'rdate'
        },
        {
            title: 'Planned Completion Date',
            width: 140,
            dataIndex: 'pdate',
            key: 'pdate'
        },
        {
            title: 'Actual Completion Date',
            width: 140,
            dataIndex: 'adate',
            key: 'adate'
        },
        {
            title: 'BV Location',
            width: 140,
            dataIndex: 'blocation',
            key: 'blocation'
        }
    ];
    function handleOkMP() {
        setIsModalOpenMP(false);
    }
    function handleCancelMP() {
        setIsModalOpenMP(false);
    }
    function getLstMultiProduct(projectId) {
        getPrjEEMasterProducts(projectId).then((responseData) => {
            setLstMultiProduct(responseData);
        });
    }
    function handleOpenMultiProdModal(projectId) {
        if (projectId) {
            setIsModalOpenMP(true);
            getLstMultiProduct(projectId);
        }
    }
    return (
    // <Card
    //   size={tableDataItem ? 'small' : 'default'}
    //   style={{ borderRadius: '0px' }}
    //   title={
    //     !tableDataItem ? (
    //       <Typography.Text>
    //         Project Search Result (Total Records: {pagination.total} )
    //       </Typography.Text>
    //     ) : (
    //       `Certificate Details`
    //     )
    //   }
    //   extra={<ProjectExcelDownload data={data} searchPrjRequest={searchPrjRequest} filename='Projects' />}
    // >
    _jsxs(_Fragment, { children: [_jsx(ProjectDetailMultiproductModal, { isModalOpen: isModalOpenMP, handleOk: handleOkMP, handleCancel: handleCancelMP, modalContent: lstMultiProduct, title: 'Product Information' }), _jsx(Table, { columns: columns, dataSource: tableDataItem ? [tableDataItem] : tableData, scroll: {
                    x: 1400
                }, pagination: pagination, onChange: onChange, size: 'small', style: { borderRadius: '0px' }, loading: loading })] })
    // </Card>
    );
};
export default ProjectDataTable;
